import React, {Component} from "react";
import "./Sideload.css"
import Authentication from "../../authentication/Authentication";
import Api from "../../api/Api";
import {toast} from "react-toastify";
import SideloadUpload from "./SideloadUpload";
import Loading from "../loading/Loading";

export default class Sideload extends Component {

    constructor(props) {
        super(props);
        this.state = {
            files: [],
            showFiles: false,
            dropdown: [],
            showUploadPopup: false,
            loading: false,
            downloading: []
        };

        this.authentication = new Authentication();
    };


    setFiles = (data) => {
        this.setState({
            files: JSON.parse(data),
            showFiles: true,
            loading: false
        })
    }

    updateDropdown = (file) => {
        let newDropdown;

        if (this.state.dropdown.includes(file)) {
            newDropdown = [...this.state.dropdown]
            newDropdown = newDropdown.filter((folder) => folder !== file)
        } else {
            newDropdown = [...this.state.dropdown, file]
        }

        this.setState({
            dropdown: newDropdown
        })
    }

    useDownloadUrl = (url, resourceType, filePath) => {
        fetch(url).then(
            response => {
                return response.blob()
            }).then(blob => {
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url;
                a.download = filePath ? filePath.split("/")[filePath.split("/").length - 1] : `${this.props.domain}_${resourceType.replace("/", "_")}.tar.gz`;
                a.click();


                const removeDownload = this.state.downloading.filter(item => {
                    if (filePath) {
                        return item !== filePath
                    } else {
                        return item !== resourceType
                    }
                })

                this.setState({
                    downloading: removeDownload
                })
            }
        )
    }

    handleDownload = (resourceType, filePath) => {
        const newDownloading = [...this.state.downloading]
        filePath ? newDownloading.push(filePath) : newDownloading.push(resourceType)

        this.setState({
            downloading: newDownloading
        })

        const api = new Api()

        if (this.authentication.isAdmin()) {
            api.pisaasDownloadResource(this.useDownloadUrl, function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }, this.props.domain, resourceType, this.props.region, filePath);
        }
    }

    renderImageFolder = (themeName, themeImages) => {
        return (
            <ul>
                <li className={"folder-list-item"} data-testid="config.sideloading.folderList.item" value={"img"}
                    onClick={() => this.updateDropdown("img")}><span className={"tree-structure"}></span><i
                    className="fa fa-folder"/> images<i
                    className={`fa ${this.state.dropdown.includes("img") ? "fa-caret-up" : "fa-caret-down"} gap-left-1`}/>
                </li>
                {this.state.downloading.includes(`themes/${themeName}/img`) ?
                    <i className="fa fa-spinner fa-pulse fa-3x fa-fw download-load"/> :
                    <i className="fa fa-download download"
                       onClick={() => this.handleDownload(`themes/${themeName}/img`)}
                       aria-hidden="true"/>}
                <ul>
                    {this.state.dropdown.includes("img") ? themeImages["img"].map(filePath => {
                        return (
                            <li className={"folder-list-item"} data-testid="config.sideloading.folderList.item"><span
                                className={"tree-structure"}></span><i
                                className="fa fa-file"/> {filePath.split("/")[filePath.split("/").length - 1]}
                                {this.state.downloading.includes(filePath) ?
                                    <i className="fa fa-spinner fa-pulse fa-3x fa-fw download-load"/> :
                                    <i className="fa fa-download download" aria-hidden="true"
                                       onClick={() => this.handleDownload(`themes/${themeName}/img`, filePath)}
                                    />}</li>
                        )
                    }) : <></>}
                </ul>
            </ul>
        )
    }

    createThemeStructure = (themes) => {
        return (
            <ul>
                {Object.keys(themes).map(themeName => {
                    return (
                        <>
                            <li className={"folder-list-item"} data-testid="config.sideloading.folderList.item" value={themeName}
                                onClick={() => this.updateDropdown(themeName)}><span
                                className={"tree-structure"}></span><i
                                className="fa fa-folder"/> {themeName}<i
                                className={`fa ${this.state.dropdown.includes(themeName) ? "fa-caret-up" : "fa-caret-down"} gap-left-1`}/>
                            </li>
                            {this.state.downloading.includes(`themes/${themeName}`) ?
                                <i className="fa fa-spinner fa-pulse fa-3x fa-fw download-load"/> :
                                <i className="fa fa-download download"
                                   onClick={() => this.handleDownload(`themes/${themeName}`)}
                                   aria-hidden="true"/>}
                            <ul>
                                {this.state.dropdown.includes(themeName) ? this.renderImageFolder(themeName, themes[themeName]) : <></>}
                                {this.state.dropdown.includes(themeName) ? themes[themeName]["files"].map(filePath => {
                                    return (
                                        <li className={"folder-list-item"} data-testid="config.sideloading.folderList.item"><span
                                            className={"tree-structure"}></span><i
                                            className="fa fa-file"/> {filePath.split("/")[filePath.split("/").length - 1]}
                                            {this.state.downloading.includes(filePath) ?
                                                <i className="fa fa-spinner fa-pulse fa-3x fa-fw download-load"/> :
                                                <i
                                                    className="fa fa-download download" aria-hidden="true"
                                                    onClick={() => this.handleDownload(`themes/${themeName}`, filePath)}
                                                />}</li>
                                    )
                                }) : <></>}
                            </ul>
                        </>
                    )
                })
                }
            </ul>
        )
    }

    renderFileTree = (files) => {
        return (
            <div>
                <ul>
                    <li className={"folder-list-item"} data-testid="config.sideloading.folderList.parentItem"><i className="fa fa-folder"/> root</li>
                    {Object.keys(files).map(file => {
                            return (
                                <ul>
                                    <li className={"folder-list-item"} data-testid="config.sideloading.folderList.item" value={file}
                                        onClick={() => this.updateDropdown(file)}><span className={"tree-structure"}></span><i
                                        className="fa fa-folder"/> {file}<i
                                        className={`fa ${this.state.dropdown.includes(file) ? "fa-caret-up" : "fa-caret-down"} gap-left-1`}/>
                                    </li>
                                    <>
                                        {this.state.downloading.includes(file) ?
                                            <i className="fa fa-spinner fa-pulse fa-3x fa-fw download-load"/> :
                                            <i className="fa fa-download download" onClick={() => this.handleDownload(file)}
                                               aria-hidden="true"/>}
                                    </>
                                    <ul>
                                        {this.state.dropdown.includes(file) ? file === "themes" ? this.createThemeStructure(files[file]) : files[file].map(filePath => {
                                            return (
                                                <>
                                                    <li className={"folder-list-item"} data-testid="config.sideloading.folderList.item"><span
                                                        className={"tree-structure"}></span><i
                                                        className="fa fa-file"/> {filePath.split("/")[filePath.split("/").length - 1]}
                                                        {this.state.downloading.includes(filePath) ?
                                                            <i className="fa fa-spinner fa-pulse fa-3x fa-fw download-load"/> :
                                                            <i
                                                                className="fa fa-download download" aria-hidden="true"
                                                                onClick={() => this.handleDownload(file, filePath)}
                                                            />}
                                                    </li>
                                                </>
                                            )
                                        }) : <></>}
                                    </ul>
                                </ul>
                            )
                        }
                    )}
                </ul>
            </div>
        )
    }

    handleScan(domain) {
        this.setState({
            loading: true
        })

        const api = new Api();

        api.pisaasSideload(this.setFiles, function (err) {
            console.log(err);
            toast.error("Failed to fetch Pisaas Instances", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }, domain, this.props.region);
    }

    toggleUploadModal = () => {
        this.setState({
            showUploadPopup: !this.state.showUploadPopup
        })
    }

    render() {
        return (
            <>
                <h2 className={"config-header"} data-testid="config.header.sideloading">Sideloading</h2>
                <ul>
                    <li>Load images, themes, svgs and custom jdbcs onto your instance</li>
                    <li>Scan for existing resources</li>
                </ul>
                <div className={"sideload-nav"} data-testid="config.sideloading.nav">
                    <button onClick={() => this.handleScan(this.props.domain)}
                            className={"try-pi-button sideload-button"} data-testid="config.sideloading.button.scan">Scan
                    </button>
                    <button onClick={() => this.toggleUploadModal()}
                            className={"try-pi-button sideload-button"} data-testid="config.sideloading.button.upload">Upload
                    </button>
                </div>
                {this.state.showUploadPopup ?
                    <SideloadUpload togglePopUp={this.toggleUploadModal} domain={this.props.domain} region={this.props.region}/> : <></>}
                {this.state.loading ? <Loading/> : this.state.showFiles ? this.renderFileTree(this.state.files) : <></>}
            </>
        )
    }
}



